import { terminalConnection } from '../socket';
import { terminalActions } from '../action';
import { RTCStreamSingleton } from '../socket';
import { terminalStore } from '../store';
import { dialogEvents } from '../component';
const tC = terminalConnection;

const rS = RTCStreamSingleton.getConnection();

export function isAutocompleteEvent(message: any): boolean {
  return message.endpoint == 'TerminalAutocomplete';
}

export function isCreateTerminalFailed(message: any): boolean {
  return message.endpoint == 'CreateTerminalFailed';
}

export function isOutputEvent(
  name: string,
  message: any,
): message is TerminalInfo.Output {
  return message.endpoint == 'TerminalOutput';
}

export function isOutputMessageEvent(
  message: any,
): message is TerminalInfo.Output {
  return message.endpoint == 'TerminalOutput';
}

export function isCreatedEvent(message: any): message is TerminalInfo.Created {
  return message.endpoint == 'CreateTerminal';
}

export function isClosedEvent(message: any): message is TerminalInfo.Closed {
  return message.endpoint == 'CloseTerminal';
}

function getDescriptor(message: TerminalInfo.Created) {
  return {
    terminalType: message.terminalType,
    id: message.terminalId,
    currentPath: message.currentPath,
  };
}

export let terminalApi = {
  autocomplete(
    command: string,
    forward: boolean,
    cursorIndex: number,
    terminalId: string,
  ) {
    tC.callEndpoint('TerminalAutocomplete', [
      command,
      forward,
      cursorIndex,
      terminalId,
      tC.nextCorrelationId(),
    ]);
  },
  input(command: string, terminalId: string) {
    tC.callEndpoint('TerminalInput', [
      command,
      terminalId,
      tC.nextCorrelationId(),
    ]);
  },
  create(terminalType: string) {
    terminalActions.expectTerminal();
    tC.callEndpoint('CreateTerminal', [terminalType, tC.nextCorrelationId()]);
  },
  close(terminalId: string) {
    tC.callEndpoint('CloseTerminal', [terminalId, tC.nextCorrelationId()]);
  },
};

export function initialize() {
  //terminalConnection.connect(appStore.getState().connection.host, "22008")
}

//LOG tC.fallbackListen(console.log.bind(console))

tC.listenAll<typeof tC>(
  [
    isCreatedEvent,
    (msg: TerminalInfo.Created) => {
      terminalActions.addTerminal(getDescriptor(msg));
    },
  ],
  [
    isClosedEvent,
    (msg: TerminalInfo.Closed) => {
      terminalActions.removeTerminal(msg.terminalId);
    },
  ],
  [
    isOutputMessageEvent,
    (msg: TerminalInfo.Output) => {
      terminalActions.output(msg);
    },
  ],
  [
    isAutocompleteEvent,
    (msg: TerminalInfo.AutocompleteData) => {
      terminalActions.autocomplete(msg);
    },
  ],
  [
    isCreateTerminalFailed,
    (msg: string) => {
      terminalActions.cancelExpectTerminal();
      dialogEvents.dialog({
        title: 'Create Terminal Failed',
        body: msg,
      });
    },
  ],
);

rS.listenKeys(isOutputEvent, {
  outputTerminalData(msg: TerminalInfo.Output) {
    //console.log(msg)
    terminalActions.output(msg);
  },
});
